import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { categoryEdit } from "./categoryAsyncThunk";
import ImageCreate from "../image/ImageCreate";
import {
  styled,
  ThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";

import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import {
  Dialog,
  StyledDialogTitle,
  StyledTextField,
} from "../../components/CustomComponents";
import { BlueButton, BlackButton } from "../../components/CustomButtons";

const ImgCategoryLogo = styled("img")(({ theme }) => ({
  width: theme.spacing(10),
  objectFit: "cover",
}));

function CategoryEdit({ isSelected, data }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [isUserActionMade, setIsUserActionMade] = useState(false);
  const [values, setValues] = useState({
    id: data.id,
    name: data.name,
    imageURL: data.imageURL,
  });
  const [showHint, setShowHint] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleValues = (prop) => (event) => {
    setIsUserActionMade(true);
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleSubmit = () => {
    setIsUserActionMade(true);
    if (Boolean(values.name) === false) {
      setShowHint(true);
      return;
    }
    setShowHint(false);
    dispatch(categoryEdit(values));
  };

  useEffect(() => {
    const { id, name, imageURL, parent_id } = data;
    setValues({ id, name, imageURL, parent_id });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  return (
    <React.Fragment>
      <BlueButton
        variant="contained"
        color="primary"
        disabled={isSelected === false}
        sx={{ m: 1 }}
        onClick={handleClickOpen}
      >
        Edit
      </BlueButton>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-edit-category"
        scroll="body"
        maxWidth="xs"
        fullWidth
      >
        <StyledDialogTitle id="form-dialog-edit-category" onClose={handleClose}>
          Edit Category
        </StyledDialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <StyledTextField
            autoFocus
            required
            error={isUserActionMade && Boolean(values.name) === false}
            defaultValue={values.name}
            onChange={handleValues("name")}
            variant="outlined"
            margin="dense"
            size="small"
            id="category-name"
            sx={{ mt: 0, mb: 1.5 }}
            placeholder="Name"
            fullWidth
          />
          <ImageCreate
            label="Image URL"
            svg={!values.parent_id ? true : false}
            onFinish={(image) => setValues({ ...values, imageURL: image.url })}
          />
          {values.imageURL && (
            <ImgCategoryLogo src={values.imageURL} alt="Category" />
          )}
          {!values.parent_id && (
            <p style={{ fontSize: "12px", color: "#F75D59" }}>
              <b>Note - </b> If you are uploading a category icon, please ensure
              that the image dimensions are 50 x 50 pixels.
            </p>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            justifyContent: "center",
            flexDirection: "column",
            px: 3,
          }}
        >
          <BlackButton
            variant="contained"
            color="primary"
            sx={{
              width: "100%",
              margin: (theme) => theme.spacing(0, 0, 3, 0),
            }}
            onClick={handleSubmit}
          >
            Update Category
          </BlackButton>
        </DialogActions>
        {showHint && (
          <DialogContentText
            sx={{
              margin: (theme) => theme.spacing(0, 3, 3, 3),
              textAlign: "center",
            }}
          >
            Oops! Something is still wrong above.
          </DialogContentText>
        )}
      </Dialog>
    </React.Fragment>
  );
}

CategoryEdit.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    imageURL: PropTypes.string,
    created_at: PropTypes.object,
    updated_at: PropTypes.object,
  }).isRequired,
};

export default CategoryEdit;
